import { render, staticRenderFns } from "./relic-detail-base-map.vue?vue&type=template&id=12fa65ee"
import script from "./relic-detail-base-map.vue?vue&type=script&lang=js"
export * from "./relic-detail-base-map.vue?vue&type=script&lang=js"
import style0 from "./relic-detail-base-map.vue?vue&type=style&index=0&id=12fa65ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports